export default "__VITE_ASSET__DXllPjAY__"